var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6.99984C3.5 6.67767 3.74742 6.4165 4.05263 6.4165H9.94737C10.2526 6.4165 10.5 6.67767 10.5 6.99984C10.5 7.322 10.2526 7.58317 9.94737 7.58317H4.05263C3.74742 7.58317 3.5 7.322 3.5 6.99984Z",
    fill: "#506176"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGrey);
export default __webpack_public_path__ + "static/media/error-grey.9f243ca4d50b0167566c0bc707f42151.svg";
export { ForwardRef as ReactComponent };